import { render, staticRenderFns } from "./AppletOrderDetails.vue?vue&type=template&id=2f12e178&scoped=true&"
import script from "./AppletOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AppletOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppletOrderDetails.vue?vue&type=style&index=0&id=2f12e178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12e178",
  null
  
)

export default component.exports